export default "__VITE_ASSET__BFbbckke__"